module.exports = __webpack_public_path__ + "static/media/select-search.e137998d.png";